export const DECLARE_WARRANTY_STATE_ENUM = {
  inWarranty: 'IN_WARRANTY',
  thirdPartyRepair: 'THIRD_PARTY_REPAIR',
  waterOrDropped: 'WATER_OR_DROPPED',
} as const

export const RESOLUTION_OPTIONS_ACTIONS_ENUM = {
  createShipment: 'CREATE_SHIPMENT',
  showDataRemoval: 'SHOW_DATA_REMOVAL',
  showPictures: 'SHOW_PICTURES',
  showPicturesWithIntro: 'SHOW_PICTURES_WITH_INTRO',
  showMessage: 'SHOW_MESSAGE',
} as const

export const RESOLUTION_OPTION_TYPE_ENUM = {
  aiChat: 'AI_CHAT',
  intercomAsyncChat: 'INTERCOM_ASYNC_CHAT',
  intercomLiveChat: 'INTERCOM_LIVE_CHAT',
  factoryRepair: 'FACTORY_REPAIR',
  shopRepair: 'SHOP_REPAIR',
  repairReplace: 'REPAIR_REPLACE',
  remoteAssistance: 'REMOTE_ASSISTANCE',
  refund: 'REFUND',
  sellerRepair: 'SELLER_REPAIR',
  sellerReplace: 'SELLER_REPLACE',
  replace: 'REPLACE',
  liveChat: 'LIVE_CHAT',
  straightRefund: 'STRAIGHT_REFUND',
  expressReplace: 'EXPRESS_REPLACE',
} as const

export type GetDeclaredWarrantyStateEnum =
  (typeof DECLARE_WARRANTY_STATE_ENUM)[keyof typeof DECLARE_WARRANTY_STATE_ENUM]

export type GetResolutionOptionsActionsEnum =
  (typeof RESOLUTION_OPTIONS_ACTIONS_ENUM)[keyof typeof RESOLUTION_OPTIONS_ACTIONS_ENUM]

export type GetResolutionOptionsTypeEnum =
  (typeof RESOLUTION_OPTION_TYPE_ENUM)[keyof typeof RESOLUTION_OPTION_TYPE_ENUM]
